import React, { useState } from 'react';

import { FaTags, FaTag } from 'react-icons/fa';

const tags = [
  {
    className: 'red',
  },
  {
    className: 'green',
  },
  {
    className: 'orange',
  },
  {
    className: 'grey',
  },
];

const AddTask = ({ onCancel, onAdd }) => {
  const [text, setText] = useState('');
  const [color, setColor] = useState('grey');
  const [err, setErr] = useState(false);
  const [tagModal, setTagModal] = useState(false);

  const onAddTodo = () => {
    if (text.length < 1) {
      setErr(true);
      return;
    }

    const todo = {
      id: Date.now(),
      color,
      completed: false,
      text,
    };
    onAdd(todo);
    setText('');
    setColor('grey');
    setErr(false);
  };

  const onColorSelect = (color) => {
    setColor(color);
    setTagModal(!tagModal);
  };

  const toggleTagModal = () => {
    setTagModal(!tagModal);
  };

  return (
    <div className="add-task">
      {text.length === 220 && (
        <div className="add-task__error red">Max length of task 200 characters!</div>
      )}
      {err && <div className="add-task__error red">Cant add empty task!</div>}
      <FaTags className={color} onClick={toggleTagModal} />
      {tagModal && (
        <div className="add-task__modal">
          {tags.map((tag) => {
            return (
              <FaTag
                key={tag.className}
                className={tag.className}
                onClick={() => onColorSelect(tag.className)}
              />
            );
          })}
        </div>
      )}
      <input
        autoFocus
        spellCheck="false"
        maxLength="220"
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="add-task__field"
      />
      <div className="add-task__btns">
        <button onClick={onAddTodo} className="btn btn-primary">
          Add task
        </button>
        <button onClick={onCancel} className="btn btn-secondary">
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddTask;
